var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M23.912 7.932H6.088C5.47 7.932 5 7.515 5 6.966 5 6.416 5.47 6 6.088 6h17.824C24.53 6 25 6.417 25 6.966s-.47.966-1.088.966M23.912 15.863H6.088c-.618 0-1.088-.416-1.088-.965 0-.55.47-.966 1.088-.966h17.824c.618 0 1.088.416 1.088.966 0 .549-.47.965-1.088.965M23.912 23.795H6.088c-.618 0-1.088-.417-1.088-.966s.47-.966 1.088-.966h17.824c.618 0 1.088.417 1.088.966 0 .55-.47.966-1.088.966"
  })));
};
export default SvgBurger;